module.exports = __webpack_public_path__ + "assets/f04f0bea7447a07ee2d832649a04dbba.mp3";


/*****************
 ** WEBPACK FOOTER
 ** C:/Users/jlondon/Desktop/Work-Resize/roc2/engine/public-src/spingames/panel/sounds/buttons/denom.mp3
 ** module id = 23
 ** module chunks = 0
 **/